import { Flex, Icon, Separator, Text } from '@driftt/dds'
import { faQuoteRight } from '@driftt/dds.icons/solid/faQuoteRight'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'
import React, { Fragment } from 'react'

export const AIPhrasesSamples = ({ phrases }: { phrases: string[] }) => {
  return (
    <Flex
      css={{
        border: '1px solid $purple4',
        borderRadius: '$1',
        padding: '$2',
        backgroundColor: '$purple1',
      }}
      direction="column"
    >
      <Flex alignItems="center" gap={0}>
        <Icon
          size="large"
          icon={faSparkles}
          color="purple7"
          css={{ verticalAlign: 'baseline', marginRight: '$1' }}
        />
        <Text variant="bodyBold">
          Sample phrases that would trigger this guardrail
        </Text>
      </Flex>
      <Flex direction="column" gap="half">
        {phrases.map((phrase, index) => (
          <Fragment key={index}>
            <Text>
              <Icon
                icon={faQuoteRight}
                color="gray4"
                css={{
                  marginRight: '$1',
                }}
              />
              {phrase}
            </Text>
            {index !== phrases.length - 1 && <Separator />}
          </Fragment>
        ))}
      </Flex>
    </Flex>
  )
}
